import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import {Button, Grid, IconButton} from "@mui/material";
import InputField from "../../components/InputField";
import {Add, Edit, QrCode2Outlined} from "@mui/icons-material";
import qrcode from "qrcode";
import DisplayQrcode from "../trucks/DisplayQrcode";
import ModalPage from "../../components/ModalPage";
import TableView from "../../components/TableView";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";
import AlertBar from "../../components/AlertBar";
import Form from "../../components/Form";

export default function HotelConfiguration(props) {
    const form = useRef();
    const alert = useRef();
    const modal = useRef();
    const nameRef = useRef();
    const [showProgress, setShowProgress] = useState(false);
    const [data, setData] = useState({total: 0, data: []});
    const [name, setName] = useState();
    const [propertyId, setPropertyId] = useState();
    const [canSubmit, setCanSubmit] = useState(true);

    useEffect(() => {
        loadData();
    }, [name]);
    const loadData = () => {
        let url = `${BASE_URL}api/settings/property?businessType=Hotel`;
        setShowProgress(true);
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
                setShowProgress(false)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };
    const generateQRCode = (item) => {
        qrcode.toDataURL(
            `${window.location.origin}/property-rate-review/${item?.propertyId}`,
            {
                width: 800,
                margin: 2,
                color: {
                    dark: "#335383FF",
                    light: "#EEEEEEFF",
                },
            },
            (err, url) => {
                if (err) throw new Error(err);
                let component = <DisplayQrcode qrcode={url}/>;
                modal.current.show("Qr-code", component, "20%");
            }
        );
    };

    const addHotel = () => {
        let data = {name, businessType: "Hotel"}
        if (canSubmit && form.current.validate()) {
            setCanSubmit(false);
            alert.current.showProgress();
            if (propertyId) {
                window.axios
                    .put(`${BASE_URL}api/settings/property/${propertyId}`, data)
                    .then(response => {
                        alert.current.showSuccess("Update Successfully.");
                        setCanSubmit(true);
                        setTimeout(() => {
                            setPropertyId(undefined);
                            setName("");
                            loadData();
                        }, 1000)
                    })
                    .catch(error => {
                        setCanSubmit(true);
                        reportErrors(alert.current, error);
                    });
            } else {
                window.axios
                    .post(`${BASE_URL}api/settings/property`, data)
                    .then(response => {
                        alert.current.showSuccess("Create Successfully.");
                        setCanSubmit(true);
                        setTimeout(() => {
                            setPropertyId(undefined);
                            setName("");
                            loadData();
                        }, 1000)
                    })
                    .catch(error => {
                        setCanSubmit(true);
                        reportErrors(alert.current, error);
                    });
            }
        }
    }
    const updateDetails = (item) => {
        setName(item?.name);
        setPropertyId(item?.propertyId);
    }

    return (
        <Box>
            <AlertBar ref={alert}/>
            <Form ref={form}>
                <Grid container spasing={1}>
                    <Grid item xs={11}>
                        <InputField
                            ref={nameRef}
                            required={true}
                            placeholder="Name"
                            defaultValue={name}
                            onChange={(value) => setName(value)}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <Button
                            disableElevation sx={{textTransform: "none"}}
                            fullWidth size="medium"
                            variant="contained" color="primary"
                            onClick={() => addHotel()}>
                            {propertyId ? "Update" : "Save"}
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <TableView
                            showProgres={showProgress}
                            url=""
                            title=""
                            columns={[
                                {id: 'name', label: 'Hotel Name',},
                                {
                                    id: 'status',
                                    label: 'QR Code',
                                    disabled: true,
                                    customerRender: true,
                                    valueGetter: (item) => (
                                        <IconButton size="small"
                                                    onClick={() => generateQRCode(item)}><QrCode2Outlined/></IconButton>)
                                },
                                {
                                    id: 'action',
                                    label: 'Action',
                                    minWidth: "small",
                                    disabled: true,
                                    customerRender: true,
                                    valueGetter: (item) => (
                                        <IconButton size="small"
                                                    onClick={() => updateDetails(item)}><Edit/></IconButton>)
                                },
                            ]}
                            rows={data}
                            rowClick={true}
                            rowFunction={(item) => {
                            }}
                        />
                    </Grid>
                </Grid>
            </Form>
            <ModalPage ref={modal}/>
        </Box>
    );
}